import React from 'react';
import styled from 'styled-components';
import { ReactComponent as Blob } from '../assets/hero-blob.svg';
import { THEME_COLORS } from '../utils/theme';
import { HeaderFont, PrimaryFont } from './styles';

const HeroContainer = styled.div`
  display: flex;
  margin: 10px 0;
  padding: 80px 20px;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  color: ${THEME_COLORS.brandPink};
  @media (max-width: 767px) {
    flex-direction: column;
    align-items: center;
    padding: 0;
  }
`;

const BlobContainer = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 767px) {
    height: 30vh;
  }
`;

const HeroBlob = styled(Blob)`
  @media (max-width: 767px) {
    height: 100%;
    width: 100%;
  }
`;

const DescriptionContainer = styled.div`
  flex-grow: 2;
  vertical-align: top;
  padding: 0 50px;
  margin: 20px 0;
`;

const Title = styled(HeaderFont)`
  display: block;
  font-size: 85px;
  margin-bottom: 50px;
  @media (max-width: 767px) {
    text-align: center;
    font-size: 65px;
  }
`;

const Description = styled(PrimaryFont)`
  display: block;
  font-size: 25px;
`;

export const Hero: React.FC = () => {
  return (
    <HeroContainer>
      <BlobContainer>
        <HeroBlob />
      </BlobContainer>
      <DescriptionContainer>
        <Title>STATS</Title>
        <Description>
          At DubHacks, we value transparency and diversity, and believe both should be honestly discussed and strived
          for.
          <br />
          <br />
          In that spirit, we have made our statistics on applications for every DubHacks (starting in 2015) available
          here.
          <br />
          <br />
          We hope this data may provide a better picture of DubHacks and hackathons in general, as well as prompt
          similar conversations and openness across the hacker community.
        </Description>
      </DescriptionContainer>
    </HeroContainer>
  );
};
